import { useEffect, useState, useRef } from "react";
import { getTree, getArboretum } from "./graph-structure";
import { getGlyphSlots } from "../../requests/glyphslot";

const useArboretum = ({ defaultArboretum }) => {
  const [arboretum, setArboretum] = useState(defaultArboretum);

  const arboretumRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    // Function to update dimensions
    const updateDimensions = () => {
      const update = { ...dimensions };
      if (arboretumRef.current) {
        const { offsetWidth, offsetHeight } = arboretumRef.current;
        update.width = offsetWidth;
        update.height = offsetHeight;
      }
      setDimensions(update);
    };

    // Update dimensions initially
    updateDimensions();
    // Remove any which existed already
    window.removeEventListener("resize", updateDimensions);
    // Add event listener to update dimensipons on window resize
    window.addEventListener("resize", updateDimensions);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [arboretum]);

  useEffect(() => {
    getGlyphSlots({}).then((glyphSlots) => {
      const uqTreeIds = new Set(glyphSlots.map((gs) => gs.treeId));
      const trees = Array.from(uqTreeIds).map((treeId) => {
        const relevantSlots = glyphSlots.filter((gs) => gs.treeId === treeId);
        const tree = getTree(treeId, relevantSlots);
        return tree;
      });
      setArboretum(getArboretum(trees));
    });
  }, []);

  return {
    arboretum,
    setArboretum,
    arboretumRef,
    dimensions,
  };
};

export default useArboretum;
